import React from "react"

import {hasProperty} from '../utils/utils';

import dsd from '../classes/clsDSD';

import * as PD from '../classes/pdStyle';

class ViewItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false
        };

        this.dsd = new dsd();

        this.data = {};
        this.data.Item = null;

        if (this.props.Item){
            this.data.Item = this.props.Item;
        }
    }

    componentDidMount() {
        if (this.data.Item){
            this.setState({ isLoaded: true });
        }
    }

    view(json){

        if (!json) { return null; }

        return (
            <PD.Table className="panel">
                <PD.Tbody>

                    {hasProperty(json,'code') &&
                        <PD.Tr>
                            <PD.Th>Code</PD.Th>
                            <PD.Td><PD.PdNavLink to={`/item/${json._id}`}>{json.code}</PD.PdNavLink></PD.Td>
                        </PD.Tr>
                    }

                    {hasProperty(json,'label') &&
                        <PD.Tr>
                            <PD.Th>Label</PD.Th>
                            <PD.Td>{json.label}</PD.Td>
                        </PD.Tr>
                    }

                    {hasProperty(json,'definition') &&
                        <PD.Tr>
                            <PD.Th>Definition</PD.Th>
                            <PD.Td>
                                <PD.MdPresent>{json.definition}</PD.MdPresent>
                            </PD.Td>
                        </PD.Tr>
                    }

                    {hasProperty(json,'usageNotes') &&
                        <PD.Tr>
                            <PD.Th>Usage Notes</PD.Th>
                            <PD.Td>
                                <PD.MdPresent>{json.usageNotes}</PD.MdPresent>
                            </PD.Td>
                        </PD.Tr>
                    }

                </PD.Tbody>
            </PD.Table>
        );
    }

    render() {

        if (this.state.isLoaded) {
            return (
                <div>
                    {this.view(this.data.Item)}
                </div>
            );
        }

        return null;
    }
}

export default ViewItem;
